import { c as _c } from "react/compiler-runtime";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import type { ApiWaveDecisionWinner } from "@/generated/models/ApiWaveDecisionWinner";
import WaveWinnersDropHeaderVoter from "./WaveWinnersDropHeaderVoter";
import { WAVE_VOTING_LABELS, WAVE_VOTE_STATS_LABELS } from "@/helpers/waves/waves.constants";
interface WaveWinnersDropHeaderVotersProps {
  readonly winner: ApiWaveDecisionWinner;
}
export default function WaveWinnersDropHeaderVoters(t0) {
  const $ = _c(22);
  const {
    winner
  } = t0;
  const userVote = winner.drop.context_profile_context?.rating ?? 0;
  const hasUserVoted = userVote !== 0;
  const isNegativeVote = userVote < 0;
  const userVoteClass = isNegativeVote ? "tw-text-rose-400" : "tw-text-iron-50";
  let t1;
  if ($[0] !== winner) {
    t1 = winner.drop.top_raters.map((voter, index) => <WaveWinnersDropHeaderVoter voter={voter} winner={winner} index={index} key={voter.profile.handle} />);
    $[0] = winner;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="tw-flex tw-items-center -tw-space-x-2">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== winner.drop.raters_count) {
    t3 = formatNumberWithCommas(winner.drop.raters_count);
    $[4] = winner.drop.raters_count;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = winner.drop.raters_count === 1 ? "voter" : "voters";
  let t5;
  if ($[6] !== t4) {
    t5 = <span className="tw-font-normal tw-text-iron-400">{t4}</span>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t5) {
    t6 = <span className="tw-font-medium tw-text-iron-50">{t3}{" "}{t5}</span>;
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t2 || $[12] !== t6) {
    t7 = <div className="tw-flex tw-items-center tw-gap-2 tw-whitespace-nowrap tw-text-sm tw-leading-5">{t2}{t6}</div>;
    $[11] = t2;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== hasUserVoted || $[15] !== userVote || $[16] !== userVoteClass || $[17] !== winner.drop.wave) {
    t8 = hasUserVoted && <div className="tw-flex tw-items-center tw-gap-1.5 tw-text-sm tw-leading-5"><span className="tw-whitespace-nowrap"><span className="tw-font-normal tw-text-iron-400">{WAVE_VOTE_STATS_LABELS.YOUR_VOTES}:{" "}</span><span className={`tw-font-medium ${userVoteClass}`}>{formatNumberWithCommas(userVote)}{" "}{WAVE_VOTING_LABELS[winner.drop.wave.voting_credit_type]}</span></span></div>;
    $[14] = hasUserVoted;
    $[15] = userVote;
    $[16] = userVoteClass;
    $[17] = winner.drop.wave;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t7 || $[20] !== t8) {
    t9 = <div className="tw-flex tw-items-center tw-gap-x-4 tw-gap-y-2">{t7}{t8}</div>;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
}